module.exports = __webpack_public_path__ + "img/circle1red.58b25488.png";